import { render, staticRenderFns } from "./EcoTransesofageaList.vue?vue&type=template&id=c1442710"
import script from "./EcoTransesofageaList.vue?vue&type=script&lang=js"
export * from "./EcoTransesofageaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports